import { createAction } from "@logicsoftware/redux-toolkit";
import { put, takeEvery } from "redux-saga/effects";
import { appUrls } from "~/EasyProjectsCommon/AppUrls";
import { ApiActionInfo, api } from "~/Redux/Actions";
import { ActivityCenterFilterParams } from "../../types";
import { setCurrentPresetInStore } from "../reducers/currentPreset";

type SelectPresetParams = {
    presetId: number;
    doNotSaveCurrentIdOnServer?: boolean;
    /**
     * A marker for AC to load preset settings.
     * True by default.
     */
    loadPresetSettings?: boolean;
    /**
     * Some force filters from URL or history state.
     */
    filterParams?: ActivityCenterFilterParams;
};

export const selectPreset = createAction("PRESET/SELECT_PRESET", (data: SelectPresetParams) => ({
    payload: { ...data },
}));

export function* watchSelectPreset() {
    yield takeEvery(selectPreset, function* ({ payload: { presetId, doNotSaveCurrentIdOnServer } }) {
        yield put(setCurrentPresetInStore(presetId));

        if (!doNotSaveCurrentIdOnServer) {
            yield put(api.updateOperation(setCurrentPresetApi)({ uid: "setcurrentpreset" })(presetId));
        }
    });
}

const setCurrentPresetApi = (id: number): ApiActionInfo => ({
    endpoint: appUrls.preset.setCurrent,
    body: { id },
    additionalParams: {
        postWithAuthToken: true,
    },
});
